var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"login error-page p500\"><div class=\"wrapper-main\"><div class=\"container\"><img" + (jade.attr("src", require('./500-error-illustration.svg'), true, true)) + " width=\"280\" alt=\"\"><h2>Oops!<br>Something went wrong on our end.</h2><p>Sorry about that—If you'd like to help us resolve this issue, you can send an email to&nbsp;<a href=\"mailto:{{SUPPORT_EMAIL}}\">{{SUPPORT_EMAIL}}</a>&nbsp;describing:</p><ul><li>What link you were trying to access</li><li>How you arrived at this page (did you click a link from another site, did you type it into the browser manually, etc)</li><li>What were you doing at the time you saw this page</li></ul><a href=\"#\" ui-sref=\"root.home.landing\">Go to the Home Page</a></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/home/500/500.jade
// module id = 581
// module chunks = 0